import React from "react";
import { styled } from "@mui/system";
import { Paragraph } from "components/Typography";

const StyledDiv = styled("div")({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  width: "100%",
  height: "100%",
});

const VersionLabel = styled(Paragraph)(({ theme }) => ({
  fontSize: "12px",
  fontWeight: 500,
  color: theme.palette.text.secondary,
}));

const WrappedVersionLabel = (props) => {
  return (
    <StyledDiv>
      <VersionLabel {...props} />
    </StyledDiv>
  );
};

export default WrappedVersionLabel;
